<div class="header">
  <h1>{{ statusMessage }}</h1>
  <mat-chip-list *ngIf="statusMessage">
    <mat-chip color="primary" selected class="count-chip">{{
      productionArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter leads</mat-label>
        <input
          matInput
          (keyup)="filterProduction($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="table"
      matSort
      fixedLayout="true"
    >
      <ng-container matColumnDef="assignedName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Foreman</th>
        <td mat-cell *matCellDef="let production">
          {{ production.assignedName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let production">
          {{ production.customer || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jobAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
        <td mat-cell *matCellDef="let production">
          {{ production.jobAddress || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="contractId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract ID</th>
        <td mat-cell *matCellDef="let production">
          {{ production.contractId || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
        <td mat-cell *matCellDef="let production">
          {{ production.createdDate | date : "shortDate" : "UTC" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
        <td mat-cell *matCellDef="let production">
          {{ production.reason || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="zoneName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Office/Zone</th>
        <td mat-cell *matCellDef="let production">
          {{ production.zoneName || "n/a" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No matching results
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToProduction(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
